import authApiService from "./userApiService"; // Ensure this is your axios instance with interceptors

// Helper function to handle errors
const handleError = (error) => {
  console.error('Token Reserve API Error:', error);
  return {
    success: false,
    error: error.response?.data?.message || error.response?.data?.error || error.message || 'An unexpected error occurred',
    statusCode: error.response?.status,
    details: error.response?.data?.details || null
  };
};

// Helper function to handle successful responses
const handleSuccess = (response, message = null) => {
  return {
    success: true,
    data: response.data,
    message: message || response.data?.message || 'Operation completed successfully',
    statusCode: response.status
  };
};

export const tokenReserveService = {
  async getTokenReserve(startDate, endDate) {
    try {
      const response = await authApiService.get("/token-reserve/tax-report", {
        params: {
          startDate,
          endDate
        }
      });
      return handleSuccess(response, 'Token reserve retrieved successfully');
    } catch (error) {
      return handleError(error);
    }
  },
  async getBalanceSummary() {
    try {
      const response = await authApiService.get("/token-reserve/balance");
      return handleSuccess(response, 'Balance summary retrieved successfully');
    } catch (error) {
      return handleError(error);
    }
  },
  async getWithdrawals() {
    try {
      const response = await authApiService.get("/token-reserve/withdrawals");
      return handleSuccess(response, 'Withdrawal logs retrieved successfully');
    } catch (error) {
      return handleError(error);
    }
  },
  async withdraw({ amount, message }) {
    try {
      const response = await authApiService.post("/token-reserve/withdraw", {
        amount,
        message,
      });
      return handleSuccess(response, response.data?.message || 'Withdrawal recorded successfully');
    } catch (error) {
      return handleError(error);
    }
  },
  async resetDailyTokens() {
    try {
      const response = await authApiService.post("/token-reserve/reset-daily-tokens");
      return handleSuccess(response, 'Daily tokens reset successfully');
    } catch (error) {
      return handleError(error);
    }
  },
  async resetAllTokens() {
    try {
      const response = await authApiService.post("/token-reserve/reset-all-tokens");
      return handleSuccess(response, 'All tokens reset successfully');
    } catch (error) {
      return handleError(error);
    }
  }
};


export default tokenReserveService;
